import { useMutation } from '@tanstack/react-query';
import {
  BidvH2HService,
  InquiryTransHistoryDto,
  TransHistoryH2hEntity,
} from 'services/openapi';

export const useBidvInquiryTransHistoryMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<TransHistoryH2hEntity, Error, InquiryTransHistoryDto>({
      mutationFn: (variables: InquiryTransHistoryDto) =>
        BidvH2HService.bidvH2HControllerInquiryTransHistory(variables),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
